@for (widget of widgets(); track $index; let i = $index) {
    <web-navigation-widget-item [entity]="widget" [index]="i" [selectedEntity]="selectedEntity()" />
}
